import React from "react";
import { inject, observer } from "mobx-react/index";
import Spinner from "../../Spinner";
import { Link } from "react-router";
import DataTable from "../../DataTable";
import moment from "moment";

@inject(
  "eventTypeStore",
  "eventStore",
  "stationStore",
  "userStore",
  "ticketStatusStore",
  "ticketReasonStore",
  "ticketActionStore",
  "qcCheckStore",
  "ticketStore"
)
@observer
class EventTicketList extends React.Component {
  componentWillMount() {
    const {
      eventTypeStore,
      eventStore,
      stationStore,
      userStore,
      ticketStatusStore,
      ticketReasonStore,
      ticketActionStore,
      qcCheckStore,
      ticketStore,
    } = this.props;
    if (!eventStore.items.length) eventTypeStore.fetchItems();
    if (!eventStore.items.length) eventStore.fetchItems();
    if (!stationStore.items.length) stationStore.fetchItems();
    if (!userStore.items.length) userStore.fetchItems();
    if (!ticketStatusStore.items.length) ticketStatusStore.fetchItems();
    if (!ticketReasonStore.items.length) ticketReasonStore.fetchItems();
    if (!ticketActionStore.items.length) ticketActionStore.fetchItems();
    if (!qcCheckStore.items.length) qcCheckStore.fetchItems();
    if (!ticketStore.items.length) ticketStore.fetchItems();
  }

  flattenData = () => {
    const {
      eventStore,
      ticketActionStore,
      ticketStatusStore,
      ticketReasonStore,
      userStore,
      ticketStore,
      stationStore,
    } = this.props;

    const {
      params: { id },
    } = this.props;

    const event = eventStore.findById(id);

    if (!event || !event.event_tickets) return [];
    const result = [];
    event.event_tickets.forEach((element, index) => {
      const ticket = ticketStore.findById(+element.ticket_id);
      if (!ticket) return;

      const status = ticketStatusStore.findById(ticket.status_id);
      const reason = ticketReasonStore.findById(ticket.reason_id);
      const action = ticketActionStore.findById(ticket.action_id);
      const user = userStore.findById(ticket.assigned_to);
      const station = stationStore.findById(ticket.station_id);

      result.push({
        id: ticket.id,
        station_identifier: station && station.identifier,
        station_name: station && (
          <Link to={`/station/${station.id}/monitoring`}>{station.name}</Link>
        ),
        summary: (
          <Link to={`/monitoring/ticket/tabular/${ticket.id}/view`}>
            {ticket.summary || "View"}
          </Link>
        ),
        status: status && status.caption,
        reason: reason && reason.caption,
        action: action && action.caption,
        assigned_to: user && user.name,

        duration:
          ticket.last_log && ticket.last_log.log_date
            ? ticketStore.getDuration(moment.utc(ticket.last_log.log_date))
            : ticketStore.getDuration(moment.utc(ticket.generated_date)),
        durationValue:
          ticket.last_log && ticket.last_log.log_date
            ? new Date(moment.utc(ticket.last_log.log_date)).getTime()
            : new Date(moment.utc(ticket.generated_date)).getTime(),
      });
    });
    return result;
  };

  render() {
    if (
      this.props.eventStore.isLoading ||
      this.props.eventTypeStore.isLoading ||
      this.props.stationStore.isLoading ||
      this.props.userStore.isLoading ||
      this.props.ticketActionStore.isLoading ||
      this.props.ticketReasonStore.isLoading ||
      this.props.ticketStatusStore.isLoading
    )
      return <Spinner />;

    const data = this.flattenData();

    return (
      <div>
        <DataTable
          columns={[
            { key: "id", label: "Ticket Number" },
            { key: "station_identifier", label: "Station Identifier" },
            { key: "station_name", label: "Station Name" },
            { key: "summary", label: "Summary" },
            { key: "status", label: "Status" },
            { key: "reason", label: "Reason" },
            { key: "assigned_to", label: "Assigned to" },
            {
              key: "duration",
              label: "Duration",
              sortable: true,
              value: "durationValue",
            },
          ]}
          data={data}
          slug={"monitoring/event/list"}
        />
      </div>
    );
  }
}

export default EventTicketList;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Event/EventTicketList.js